import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts';
import EmailVerificationBanner from './EmailVerificationBanner';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return (
    <>
      <EmailVerificationBanner user={user} />
      {children}
    </>
  );
}
